import type { ReactionResourceType } from './api/types';

export const REACTIONS_SCOPE = 'block-reactions';

// API resource paths
export const RESOURCE_PATH: { [resource in ReactionResourceType]: string } = {
    article: 'articles',
    comment: 'comments',
    content: 'contents',
    event: 'events',
    'play-video': 'play-videos',
    post: 'posts',
};
